export default function(name, type, content) {
  var encodedUri = encodeURI(`data:text/${type};charset=utf-8,${content}`);
  var link = document.createElement('a');
  link.setAttribute('href', encodedUri);
  link.setAttribute('download', `${name}.${type}`);
  document.body.appendChild(link);
  link.click();
}
